import React from "react";

const NotFoundPage = () => {
  const style = `
    .video-container-wrapper {
      font-family: "Montserrat", sans-serif;
    }
    .channel-specific-radio-image {
      height: 50px;
      width: 50px;
      background: #a20d39;
      border-radius: 10px;
      padding:5px;
      margin: 5px;
    }
    .channel-specific-button {
      background:#a20d39;
      border:none;
      border-radius:10px;
      color: #fff;
      cursor: pointer;
      padding:10px;
      font-size:20px;
      margin: 5px;
    }
    .channel-specific-buttons-wrapper {
      display: flex;
      justify-content: center;
    }
    .top-banner-static-image {
      margin: 70px 0;
      text-align: center;
      position: relative;
      height: 600px;
    }
    .top-banner-static-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .radio-container {
      color: #FFF;
      margin: 100px 20px 20px 20px;
    }
    .radio-container h2, .static-page-container h3 {
      margin-top: 2rem !important;
      color: #a20d39;
      font-family: "Montserrat", sans-serif;
    }
    .radio-container p {
      margin: 0.5rem 0 !important;
      font-size: 18px;
      font-family: "Montserrat", sans-serif;
    }
    .radio-container h3 {
      font-size: 22px !important;
      font-family: "Montserrat", sans-serif;
    }
    .radio-container a {
      color: #a20d39;
      font-weight: bold;
    }
    .custom-hero-container {
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Helsinki-herojpg.jpg");
      background-size: cover;
      background-position: center;
      height: 500px;
      margin-bottom: 20px;
    }
    .custom-hero-heading {
      position: absolute;
      top: 15%;
      left: 10%;
      margin: 0;
      font-size: 2em;
    }
    .location-img {
      text-align: center;
    }
    .mhz {
      text-align: right;
      color: #a20d39;
      margin: 10px;
    }
    .map-hero-container {
      margin-top: 20px;
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Helsinki-web.jpg");
      background-size: cover;
      background-position: center;
      height: 600px;
    }
    .portrait-mobile-image {
      display: none;
    }
    .notFoundTitle {
      font-size: 39px !important;
      font-weight: 700;
      color: white;
      margin-bottom: 50px;
      font-family: "Montserrat", sans-serif;
      margin-top: 40px;
    }
    .custom-hero-heading h1 {
      font-size: 50px !important;
      color: white;
      margin-bottom: 50px;
      font-family: "Montserrat", sans-serif;
    }
    .custom-hero-heading p {
      font-size: 22px !important;
      font-family: "Montserrat", sans-serif;
    }
    .main-headline-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    .midContentWrapper{padding:0 15px;}
    .not-found-buttons{display:flex;gap:10rem;justify-content:center;margin-top:50px}
    @media screen and (max-width: 767px) {
      .not-found-buttons {display: grid;gap:2rem;padding:20px;}
    }
    @media screen and (max-width: 1023px) {
      .custom-hero-heading .logoImage {width: 150px;margin-left:15rem;}
      .custom-hero-heading { top: 15%;left: 0;width: 100%; }
      .custom-hero-heading h1 {
        font-size: 30px !important;
        margin-bottom: 20px;
      }
      .custom-hero-container {
        background-image: url("/assets/Helsinki-heromobiili.jpg");
      }
      .map-hero-container {
        background-image: url("/assets/Helsinki-mobile.jpg");
        background-position: bottom center;
      }
      .big-desktop-image { display: none; }
      .portrait-mobile-image { display: block; }
      .contact-item { width: 100% !important; }
    }
    .plans-static-text {
      text-align: center;
    }
    .pricing-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    .pricing-card {
      border: 1px solid #ddd;
      border-radius: 10px;
      padding: 20px;
      margin: 10px;
      width: 300px;
      background: #fff;
    }
    .pricing-header {
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .pricing-price select {
      padding: 10px;
      font-size: 16px;
      width: 100%;
    }
    .pricing-features {
      margin: 10px 0;
    }
    .pricing-button-wrapper {
      text-align: center;
    }
    .pricing-button {
      min-width: 200px;
      text-align: center;
      background-color: #a20d39;
      color: white;
      padding: 10px 20px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
    }
    .bottom-red-border {
      margin-top: 10px;
      height: 4px;
      background-color: #a20d39;
      border-radius: 2px;
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="video-container-wrapper">
        <div className="top-banner-static-image">
          <div className="custom-hero-heading">
            <h1>Oho!<br />Sivua ei löytynyt</h1>
            <img className="logoImage" src="/icons/radio_dei_plus.svg" width="100" height="100" alt="Radio Dei Plus" />
          </div>
          <img src="/assets/404-hero.jpeg" className="big-desktop-image" alt="Desktop Hero" />
          <img src="/assets/404-mobile-hero.jpeg" className="portrait-mobile-image" alt="Mobile Hero" />
        </div>
        <div class="midContentWrapper">
          <div className="plans-static-text">
            <h2 class="notFoundTitle">Tervetuloa uudistuneeseen Dei Plus -palveluun!</h2>
            <p>Löydät jatkossa täältä kaikki Radio Dein ja Dei Plussan sisällöt ja palvelut. Tarjoamme jatkuvasti uudistuvaa ja laadukasta<br/> sisältöä: podcast- ja videosarjoja sekä kaikki Radio Dein radiokanavat - kuunneltavissa ja katsottavissa missä ja milloin <br/>tahansa.</p>
          </div>

          <div className="plans-static-text">
            <p>Voit siirtyä uudistuneeseen palveluun alla olevien painikkeiden avulla tai valita sen yläreunan valikosta.</p>
          </div>
          </div>
        <div class="not-found-buttons">
          <a class="pricing-button" href="/">
            Etusivulle
          </a>
          <a class="pricing-button" href="/radiot">
            Radiokanavat
          </a>
        </div>
      </div>
    </>
  );
};

export { NotFoundPage };
